import React from 'react';

import { func, string } from 'prop-types';

import * as classes from './FilterChip.module.css';

const FilterChip = ({
    item,
    removeFilter,
    view,
    ...props
}) => {

    return (
        <span className={`${classes.FilterChip} ${view && view === 'User' ? classes.FilterChipForUser : ''}`}>
            {item}
            <i
                onClick={removeFilter}
                role="none"
                onKeyDown={removeFilter}
                className={`far fa-times-circle fa-lg ${classes.Icon}`}
            />
        </span>
    );
};

FilterChip.defaultProps = {
    item:         '',
    removeFilter: () => { }
};

FilterChip.propTypes = {
    item:         string,
    removeFilter: func
};

export default FilterChip;
